import { useState } from "react";
import "../index.css";

function Loading() {

 const [progress,setProgress] = useState(0)

  return (
    <>
      {/* <div className="progress-bar">
        <div className="progress-bar-title">Loading</div>
        <div className="progress" style={{ width: `${progress}%` }}></div>
      </div> */}

      return <div class="loader"></div> 

    </>
  );
}

export default Loading;
